import { useEffect } from "react";
import errorimage from "../image/warning.svg";
import secureLocalStorage from "react-secure-storage";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

function Error() {
  window.onpopstate = (e) => {
    secureLocalStorage.clear();
    Navigate("/");
  };
  useEffect(() => {
    secureLocalStorage.clear();
  }, []);
  return (
    <>
      <button className="link-text absolute flex items-center text-sm bottom-4 left-2 sm:left-2 md:left-10">
        <Icon icon="mdi:arrow-left" />
        <Link to="https://almondztrade.com"onClick={()=>secureLocalStorage.clear()}>Back to home</Link>
      </button>
      <div className="w-full">
        <div className="md:w-3/4 h-full flex justify-center items-center">
          <div>
            <img src={errorimage} className="w-[15%] m-auto" alt="error"></img>
            <h3 className="text-center font-semibold mt-4 mb-4">
              Technical Error
            </h3>
            <p className="text-center">
              We apologize, but we're currently experiencing technical issue.
              Our team is working to fix this. Please try again later.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default Error;
